export default {
  watch: {
    '$route.params.locale' (locale) {
        this.defendPath(locale)
    }
  },
  mounted () {
    this.defendPath(this.$route.params.locale)
  },
  methods: {
    defendPath (locale) {
      if (locale === 'en') {
        this.$router.push({
          name: 'Main',
          params: {
            locale: locale
          }
        })
      }
    }
  }
}
